module.exports = __webpack_public_path__ + "img/bottom-gear-C_160x160.adcaf3ff.png";